//#region imports

// react
import React, { useEffect, useState } from 'react';

//#endregion imports

const EmployeeLiveLocationTab = (props) => {

    // local states
    const { selectedDate, setSelectedDate } = props.dateProps;
    const { startRange, setStartRange, endRange, setEndRange } = props.rangeProps;
    const { startHour, setStartHour, endHour, setEndHour } = props.hourProps;
    const { empId, empName, airport } = props;

    //#region helpers
    /**
     * -- Format the range input value to a valid number or empty string
     * @param {*} v 
     * @returns 
     */
    const formateRange = (v) => {
        const cleaned = v.replace(/[^0-9]/g, '');
        if (cleaned === '') return '';
        const val = parseInt(cleaned, 10);
        return val > 0 ? val : '';
    }

    /**
     * -- Validate the time input in HH:mm format
     * @param {*} value 
     * @returns 
     */
    const validateHourInput = (value) => {
        const HOUR_REGEX = /^(?:0|[1-9]|1[0-9]|2[0-3])$/;
        return HOUR_REGEX.test(value);
    };
    //#endregion helpers

    return (
        <div className='border rounded flex-column p-3 border-end bg-light' style={{ width: 300, height: "100%", position: "sticky", top: 0 }}>

            {/* header section */}
            <div>
                <div className='fs-5 fw-semibold mb-3 p-3 border-bottom text-center'>Employee Tracker</div>
            </div>

            {/* employee details */}
            <p className='text-center' style={{ fontSize: '14px', color: 'gray', margin: 0 }}>{empName}</p>

            {/* date picker */}
            <div className='mt-5'>
                <label className='fw-semibold'>Filter by date</label>
                <input className='w-100 rounded border-0 px-3 py-2'
                    type="date"
                    value={selectedDate}
                    onChange={(e) => {
                        const date = new Date(e.target.value).toISOString().split('T')[0];
                        setSelectedDate(date);
                    }}
                >
                </input>
            </div>

            {/* range filters */}
            <div className='mt-4'>
                <label className='fw-semibold'>Filter by range (start &le; end)</label>
                <div className='d-flex flex-column gap-1'>
                    <input className='w-100 rounded border-1 px-3 py-2'
                        placeholder="Enter start number"
                        value={startRange}
                        onChange={(e) => {
                            setStartRange(formateRange(e.target.value));
                        }}
                    />
                    <input className='w-100 rounded border-1 px-3 py-2'
                        placeholder="Enter end number"
                        value={endRange}
                        onChange={(e) => {
                            setEndRange(formateRange(e.target.value));
                        }}
                    />
                </div>
            </div>

            {/* hour filter */}
            <div className='mt-4'>
                <label className='fw-semibold'>Filter by hour</label>
                <div className='d-flex flex-column gap-1'>
                    <input className='w-100 rounded border-1 px-3 py-2'
                        placeholder="Enter start hour"
                        value={startHour}
                        onChange={(e) => {
                            setStartHour(e.target.value);
                        }}
                        onBlur={() => {
                            if (startHour !== '' && !validateHourInput(startHour)) {
                                setStartHour('');
                            }
                        }}
                    />
                    <input className='w-100 rounded border-1 px-3 py-2'
                        placeholder="Enter end hour"
                        value={endHour}
                        onChange={(e) => {
                            setEndHour(e.target.value);
                        }}
                        onBlur={() => {
                            if (endHour !== '' && !validateHourInput(endHour)) {
                                setEndHour('');
                            }
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default EmployeeLiveLocationTab;
